import { store } from "../../Redux"
import { sendGA4Event } from "../../services/ga4"

import { IPaymentOptions, IPaymentOptionsLocData } from "../../config/commonInterfaces"
import { PG_EVENTS, PG_LABELS, PG_PAY_OPTIONS, PG_PAY_OPTIONS_BETA_CODES } from "./constant"

import { getIsGuestUser } from "../../utils/commonUtils"
import { checkIsBetaFeatureAvailable } from "../../helpers/betaHelper"
import { SUCCESS_MSGS } from "../../data/successMsgs"
import { AIRTEL } from "../../data/constants"
import { buyBundle, recharge } from "../../routes/routeConstants"
import { getCategory, isFromBuyBundle } from "../../helpers/commonHelpers"
import { EVENT_TYPES } from "../../data/globals"

export const isPaymentGatewayFeatureEnable = (optionName: string = "") => {
  const pgConfig = store.getState().config?.launchConfig?.paymentGatewayConfig ?? {},
  { isEnabled = false, betaCode = "" } = pgConfig[optionName as keyof typeof PG_PAY_OPTIONS_BETA_CODES] ?? {};
  return (isEnabled && (getIsGuestUser() || checkIsBetaFeatureAvailable(betaCode)))
}

export const isPaymentGatewayAvailable = (options: IPaymentOptions[], optionName: string = "") => {
  const PGOptionAvailable = options?.some((option: IPaymentOptions) => option.name === optionName);
  return PGOptionAvailable && isPaymentGatewayFeatureEnable(optionName);
}

export const isFlutterwave = (type: string = "") => {
 return type === PG_PAY_OPTIONS.UBA;
}

export const isPaystack = (type: string = "") => {
  return type === PG_PAY_OPTIONS.PAYSTACK;
}

export const sendEvents = (category: string, action: string) => {
  const isGuestUser = getIsGuestUser();
  sendGA4Event({ category: category, action: isGuestUser ? `${PG_EVENTS.GUEST}${action}` : action, target: EVENT_TYPES.ALL });
}

export const sendPGEventForCategory = (action: string, from: string) => {
  sendEvents(getCategory(from), isFromBuyBundle(from) ? `${PG_EVENTS.BUY_BUNDLE_}${action}` : `${PG_EVENTS.BUY_AIRTIME_}${action}`);
}

export const getCustomFields = (locData: IPaymentOptionsLocData) => {
  const data = locData?.data || {};
  return [
    {
      display_name: "Phone",
      variable_name: "phone",
      value: data?.msisdn
    },
    {
      display_name: "Currency",
      variable_name: "currency",
      value: data?.currency
    },
    {
      display_name: "Pack Name",
      variable_name: "packName",
      value: data?.packName
    },
    {
      display_name: "Bundle Category",
      variable_name: "bundleCategory",
      value: data?.bundleCategory
    }
  ]
}

export const PARAM_LIST = ["provisioningMsisdn", "amount", "currency", "txnId", "txnDateAndTime", "txnType", "msg", "txref", "bundleCategory"];

export const getParamValue = (param: string = "") => {
  const urlPrams = new URLSearchParams(window.location.search),
  val = urlPrams.get(param) ?? "";
  return val;
}

const getParamListValues = () => {
  return PARAM_LIST.reduce((acc: Record<string, string>, key: string) => {
    acc[key] = getParamValue(key);
    return acc;
  }, {});
}

export const getTransactionPageParamData = (getText: (key: string, ...args: string[]) => string) => {
  const { provisioningMsisdn, currency, amount, txnId, msg, txnDateAndTime, txnType, bundleCategory } = getParamListValues(),
  fromBuyBundle = isFromBuyBundle(txnType);
  return {
    mobileNumber: provisioningMsisdn,
    totalAmount: amount,
    currency,
    txnId,
    transactionDateAndTime: txnDateAndTime,
    message: msg,
    type: PG_LABELS.PG_NAVIGATION,
    useParamData: !!txnId,
    ...(fromBuyBundle ?
      { from: buyBundle.BUNDLE_MENU, operator: undefined, successInformation: getText(SUCCESS_MSGS.BUY_BUNDLE_SUCCESS_MSG, currency, amount), bundleCategory: bundleCategory } :
      { from: recharge.RECHARGE, operator: AIRTEL, successInformation: getText(SUCCESS_MSGS.BUY_AIRTIME_FOR_OTHERS_SUCCESS_MSG, currency, amount), bundleCategory: undefined })
  };
}